import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useRef, useState, cloneElement, useImperativeHandle, createElement } from 'react';
import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import { cleanChildren } from '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Flex from '../Flex/index.esm.js';
import { useId } from '@reach/auto-id';

var RadioGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onChange = _ref.onChange,
      name = _ref.name,
      defaultValue = _ref.defaultValue,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      valueProp = _ref.value,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? inline ? 'space-x-4' : 'space-y-2' : _ref$spacing,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["onChange", "name", "size", "defaultValue", "inline", "value", "spacing", "children"]);

  var _useRef = useRef(valueProp != null),
      isControlled = _useRef.current;

  var _useState = useState(defaultValue || null),
      value = _useState[0],
      setValue = _useState[1];

  var internalValue = isControlled ? valueProp : value;
  var rootRef = useRef(null);

  var internalOnChange = function internalOnChange(event) {
    if (!isControlled) {
      setValue(event.target.value);
    }

    if (onChange) {
      onChange(event, event.target.value);
    }
  }; // If no name is passed, we'll generate a random, unique name


  var fallbackName = "radio-" + useId();
  var internalName = name || fallbackName;
  var validChildren = cleanChildren(children);
  var clones = validChildren.map(function (child) {
    return cloneElement(child, {
      name: internalName,
      onChange: internalOnChange,
      checked: child.props.value === internalValue
    });
  }); // Calling focus() on the radiogroup should focus on the selected option or first enabled option

  useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        var _rootRef$current;

        var input = rootRef == null ? void 0 : (_rootRef$current = rootRef.current) == null ? void 0 : _rootRef$current.querySelector('input:not(:disabled):checked');

        if (!input) {
          var _rootRef$current2;

          input = rootRef == null ? void 0 : (_rootRef$current2 = rootRef.current) == null ? void 0 : _rootRef$current2.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  return createElement(Flex, _extends({}, rest, {
    ref: rootRef,
    role: "radiogroup",
    flexDirection: inline ? 'flex-row' : 'flex-col',
    space: spacing
  }), clones);
});
RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
//# sourceMappingURL=index.esm.js.map
